import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import isEmpty from 'utilities/isEmpty';
/**
 * Hook for disabling fields on Add User if the email is valid and the user exists
 * @returns
 */
export function useDisabledFields() {
  /**
   * Disable email if lookup was successful
   * @type {boolean}
   */
  const userEmailLookupLoaded = useSelector((state) => state.userStore.userEmailLookupLoaded);

  /**
   * Checks if user email exists in b2c
   * @type {boolean}
   */
  const userEmailExists = useSelector((state) => state.userStore.userEmailExists);

  /**
   * Checks if user in b2c has a given name and surname in their account
   * @type {boolean}
   */
  const userEmailDetails = useSelector((state) => !isEmpty(state.userStore.userEmailLookup?.user));

  /**
   * Disable given name and surname if email validation not triggered or user details exists already
   */
  const disableFields = useMemo(
    () => !userEmailLookupLoaded || (userEmailExists && userEmailDetails),
    [userEmailExists, userEmailLookupLoaded, userEmailDetails]
  );

  return { isEmailDisabled: userEmailLookupLoaded, disableFields };
}
